<template>
<b-tab no-body @click="getCode">
    <template slot="title">
        Patient Portal
    </template>
    <b-overlay
        :show="$store.getters['loading/isLoading']('connect')"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary">
        <div class="d-flex justify-content-center align-items-center">
            <qrcode :value="qrcode"></qrcode>
        </div>
        <div v-if="!qrcode" class="d-flex justify-content-center align-items-center">
             <b-list-group>
                <b-list-group-item class="d-flex align-items-center">
                    <b-avatar variant="warning" size="16px" class="mr-3"><i class="fa-solid fa-star fa-2xs"></i></b-avatar>
                    <span class="mr-auto">Patient ID, Passport or Licence number is required for generating code</span>
                </b-list-group-item>
            </b-list-group>
        </div>
    </b-overlay>
</b-tab>
</template>
<script>
import Vue from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import TabExtension from './TabExtension'
import _ from 'lodash'

export default TabExtension.extend({
    name: 'patient-portal',
    data() {
        return {
            qrcode: null
        }
    },
    methods: {
        ...mapActions('patients', ['getPatientQRCode']),
        async getCode() {
            if (this.patient) {
                this.qrcode = await this.getPatientQRCode()
            }
        }
    },
    beforeDestroy() {
        this.qrcode = null
    }
})
</script>